import React from "react";
import { Routes, Route } from "react-router-dom";
import { EmailAutomationPipelineListPage } from "./EmailAutomationPipelineListPage";
import { EmailAutomationPipelineConfigPage } from "./EmailAutomationPipelineConfigPage";
import { EmailAutomationPipelineResultsPage } from "./EmailAutomationPipelineResultsPage";
import { EmailAutomationPipelineMonitoringPage } from "./EmailAutomationPipelineMonitoringPage";

export function EmailAutomationPipelineRoutes() {
  return (
    <Routes>
      <Route path="/" element={<EmailAutomationPipelineListPage />} />
      <Route path="/config/:configId" element={<EmailAutomationPipelineConfigPage />} />
      <Route path="/result/:resultId" element={<EmailAutomationPipelineResultsPage />} />
      <Route path="/monitoring/:configId" element={<EmailAutomationPipelineMonitoringPage />} />
    </Routes>
  );
}
